import { useState, useCallback } from 'react'
import PageSection from '../../../../shared/components/layouts/PageSection'
import FormDrawer from '../../../../shared/components/drawers/FormDrawer'
import IngressControllersSection from './IngressControllersSection'
import IngressControllerForm from './IngressControllerForm'

function ProjectIngressControllersTab({
  ingressControllers,
  services,
  networks,
  loading,
  createIngressController,
  updateIngressController,
  onSuccess
}) {
  const [drawer, setDrawer] = useState({ open: false, ingressController: null })

  const handleOpenDrawer = useCallback((ingressController = null) => {
    setDrawer({ open: true, ingressController })
  }, [])

  const handleCloseDrawer = useCallback(() => {
    setDrawer({ open: false, ingressController: null })
  }, [])

  const handleSuccess = useCallback(() => {
    setDrawer({ open: false, ingressController: null })
    onSuccess()
  }, [onSuccess])

  return (
    <>
      <PageSection titleId="dockerProjects.sections.ingressControllers" loading={loading}>
        <IngressControllersSection
          ingressControllers={ingressControllers}
          services={services}
          networks={networks}
          onCreateClick={() => handleOpenDrawer()}
          onEditClick={handleOpenDrawer}
        />
      </PageSection>

      <FormDrawer
        open={drawer.open}
        onClose={handleCloseDrawer}
        titleId={drawer.ingressController ? 'ingressControllers.edit.title' : 'ingressControllers.create.title'}
      >
        <IngressControllerForm
          ingressController={drawer.ingressController}
          services={services}
          networks={networks}
          createIngressController={createIngressController}
          updateIngressController={updateIngressController}
          onSuccess={handleSuccess}
          onCancel={handleCloseDrawer}
        />
      </FormDrawer>
    </>
  )
}

export default ProjectIngressControllersTab
